module.exports = __webpack_public_path__ + "img/guide_icon_2.59565aa3.svg";